<template>
  <Modal ref="modal" title="Relatório de consultas ao GETRAN" @cancel="close">
    <form class="export-container" @submit.prevent="handleSubmit">
      <Input legend="E-mail do usuário" :modelValue="email" @update:modelValue="$event => email = $event" />

      <Period legend="Insira o período" :firstModelValue="initialDate" :secondModelValue="finalDate"
        @update:firstModelValue="$event => (this.initialDate = $event)"
        @update:secondModelValue="$event => (this.finalDate = $event)" :disabled="loading" />

      <div class="format-container">
        <span>Em qual formato de exportação?</span>

        <RadioButtons :options="radioOptions" name="format" :modelValue="format"
          @update:modelValue="$event => this.format = $event" />
      </div>

      <Button type="submit" text="Fazer download" color="primary" :disabled="loading">
        <TrayArrowDown :size="18" />
      </Button>
    </form>
  </Modal>
</template>

<script>
import Modal from 'core/Modal'
import LoadingSpinner from 'core/LoadingSpinner'
import Input from 'core/Input'
import Period from 'core/Period'
import RadioButtons from 'core/RadioButtons'
import Button from 'core/Button'
import TrayArrowDown from 'icons/TrayArrowDown'
import _export from '../../../../services/export'

export default {
  name: 'CunsultasAlunosModal',
  components: {
    Modal,
    LoadingSpinner,
    Input,
    Period,
    RadioButtons,
    Button,
    TrayArrowDown,
  },
  data() {
    return {
      email: '',
      initialDate: '',
      finalDate: '',
      format: 'pdf',
      radioOptions: [
        { value: "pdf", label: "PDF", info: "(Documento)" },
        { value: "csv", label: "CSV", info: "(Planilha)" },
        { value: "txt", label: "TXT", info: "(Texto sem formatação)", disabled: true },
      ],
      loading: false,
    }
  },
  methods: {
    async open() {
      this.$refs.modal.open()
    },
    close() {
      this.$refs.modal.close()

      this.email = ''
      this.initialDate = ''
      this.finalDate = ''
      this.format = 'pdf'
      this.loading = false
    },
    async handleSubmit() {
      if (!this.validateInputs()) {
        return
      }

      this.loading = true

      const params = {
        format: this.format,
      }

      if (this.email) params.email = this.email

      if (this.initialDate && this.finalDate) {
        params.dateI = this.initialDate
        params.dateF = this.finalDate
      }

      await this.$http.get(`${process.env.VUE_APP_URL_API_V2}/alunos/relatorio/getran/consultas`, {
        params,
      })
        .then((res) => {
          if (this.format === 'pdf') {
            _export.downloadPDF(res.body.dados, 'alunos-consultados')
          } else if (this.format === 'csv') {
            _export.downloadCSV(res.body.dados, 'alunos-consultados')
          }
        })
        .catch((err) => {
          this.$toasted.show(`Erro ao tentar gerar relatório`, {
            position: 'top-right',
          })
          this.$toasted.show(err.body.mensagem, {
            position: 'top-right',
          })
        })
        .finally(() => {
          this.loading = false
        })
    },
    validateInputs() {
      if ((this.initialDate && !this.finalDate) || (!this.initialDate && this.finalDate)) {
        this.$toasted.show('Ambos os campos de período devem ser preenchidos.', {
          icon: 'fa-times',
          position: 'top-right',
        })
        return false
      }

      if (this.initialDate && this.finalDate) {
        const initial = new Date(this.initialDate)
        const final = new Date(this.finalDate)

        if (final < initial) {
          this.$toasted.show('A data final deve ser maior ou igual à data inicial!', {
            icon: 'fa-times',
            position: 'top-right',
          })
          return false
        }
      }

      return true
    },
  }
}
</script>

<style lang="scss" scoped>
.loading {
  width: 20vw;
  display: flex;
  justify-content: center;
  align-items: center;
}

.export-container {
  display: flex;
  flex-direction: column;
  gap: 2rem;

  .format-container {
    display: flex;
    flex-direction: column;
    gap: 0.5rem;

    span {
      font-size: 1rem;
      font-weight: 600;
      line-height: 21.82px;
      color: #606264;
    }
  }

  button {
    justify-content: center;
  }
}
</style>